import type { BaseFormElement } from '@/formbuilder/formBuilder.constants';

export type FlexLayoutSplitterProps = {
  component: 'FlexLayoutSplitter';
  name: string;
} & BaseFormElement;

export const FlexLayoutSplitter = ({ testId }: FlexLayoutSplitterProps) => {
  return <></>;
};
